export enum PaymentState {
  Timeout = "Timeout",
  Error = "Error",
  Success = "Success",
}
